import React, { useEffect, useState } from "react";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import imagemLampada from "../assets/images/lampada.png";
import imagemGota from "../assets/images/gota.png";
import FaturaEnergiaAdm from "./faturaEnergiaAdm";
import FaturaAguaAdm from "./faturaAguaAdm";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { setTipoModoTela } from "./faturaActions";

function FaturaAdm(props) {
    const [state, setState] = useState({
        abaEnergiaAtiva: props.usuarioLogado.acesso_fatura_energia,
        abaAguaAtiva: !props.usuarioLogado.acesso_fatura_energia, //se nao tem acesso a energia, ativa a agua
    });

    useEffect(() => {
        props.setTipoModoTela("admin");

        return () => props.setTipoModoTela(null);
    }, []);

    if (props.tipoModoTela !== "admin") return null;

    return (
        <>
            {props.modoTela === "lista" && (
                <Grid cols="12 12 12 12" style={{ padding: "0 22px", marginBottom: -7 }}>
                    <Row style={{ paddinInline: 7 }}>
                        {props.usuarioLogado.acesso_fatura_energia && (
                            <Grid
                                cols="6 6 6 6"
                                style={{
                                    padding: "15px 0px 5px 10px",
                                    background: state.abaEnergiaAtiva ? "linear-gradient(rgb(255 192 67), rgb(215 114 30))" : "#d0d0d0",
                                    color: state.abaEnergiaAtiva ? "#ffffff" : "#333",
                                    marginBottom: -5,
                                    zIndex: state.abaEnergiaAtiva ? 1 : 0,
                                    borderRadius: "10px 10px 0 0",
                                    boxShadow: state.abaEnergiaAtiva ? "#ddd 1px -7px 8px 1px" : "none",
                                    border: "solid 1px #ddd",
                                    borderBottom: "none",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setState({
                                        ...state,
                                        abaEnergiaAtiva: true,
                                        abaAguaAtiva: false,
                                    });
                                }}
                            >
                                <h6>
                                    Energia <img style={{ marginLeft: 5 }} src={imagemLampada} height={25} alt="" />
                                </h6>
                            </Grid>
                        )}
                        {props.usuarioLogado.acesso_fatura_agua && (
                            <Grid
                                cols="6 6 6 6"
                                style={{
                                    padding: "15px 0px 5px 10px",
                                    background: state.abaAguaAtiva ? "linear-gradient(to bottom, #26a3ff, #004081)" : "#d0d0d0",
                                    color: state.abaAguaAtiva ? "#ffffff" : "#333",
                                    marginBottom: -5,
                                    zIndex: state.abaAguaAtiva ? 1 : 0,
                                    borderRadius: "10px 10px 0 0",
                                    boxShadow: state.abaAguaAtiva ? "#ddd 1px -7px 8px 1px" : "none",
                                    border: "solid 1px #ddd",
                                    borderBottom: "none",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setState({
                                        ...state,
                                        abaEnergiaAtiva: false,
                                        abaAguaAtiva: true,
                                    });
                                }}
                            >
                                <h6>
                                    Água <img style={{ marginLeft: 5 }} src={imagemGota} height={20} alt="" />{" "}
                                </h6>
                            </Grid>
                        )}
                    </Row>
                </Grid>
            )}
            <Grid cols="12 12 12 12">
                {props.usuarioLogado.acesso_fatura_energia && state.abaEnergiaAtiva && <FaturaEnergiaAdm />}
                {props.usuarioLogado.acesso_fatura_agua && state.abaAguaAtiva && <FaturaAguaAdm />}
                {!props.usuarioLogado.acesso_fatura_energia && !props.usuarioLogado.acesso_fatura_agua && (
                    <div style={{ padding: 20 }}>
                        <strong>Usuário sem permissão para visualizar faturas.</strong>
                    </div>
                )}
            </Grid>
        </>
    );
}
const mapStateToProps = (state) => {
    return {
        modoTela: state.fatura.modoTela,
        tipoModoTela: state.fatura.tipoModoTela,
        usuarioLogado: state.auth.usuarioLogado,
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ setTipoModoTela }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FaturaAdm));
